/* eslint-disable no-unused-expressions */
import { IAdFoxBannerContext } from '@cian/adfox';
import * as React from 'react';

import { IMortgageInRentStateProps } from './mortgage-in-rent-container';
import { trackMortgageInRentShow, trackMortgageInRentClick } from './tracking';

const styles = require('./mortgage-in-rent-style.css');

export interface IMortgageInRentOwnProps {
  context: IAdFoxBannerContext;
}

export interface IMortgageInRentProps extends IMortgageInRentOwnProps, IMortgageInRentStateProps {}

export class MortgageInRent extends React.PureComponent<IMortgageInRentProps> {
  public componentDidMount(): void {
    this.track(true);
  }

  public render() {
    return (
      <div
        onClick={this.clickHandler}
        style={{ backgroundImage: `url(${this.props.context.backgroundImage})` }}
        className={styles['mortgage-offer-card-banner-wrapper']}
      />
    );
  }

  private track = (isShow: boolean) => {
    const { context, tracking } = this.props;

    isShow
      ? trackMortgageInRentShow(context.reference, tracking.user, tracking.page)
      : trackMortgageInRentClick(context.reference, tracking.user, tracking.page);
  };

  private clickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    this.track(false);

    window.open(this.props.context.reference);
  };
}
